<template>
  <div v-show="!hide">
    <b-row>
      <b-col>
        <b-form-input
          size="sm"
          v-model="textFilter"
          debounce="250"
          placeholder="Search..."
          @input="currentPage = 1"
        ></b-form-input>
      </b-col>

      <b-col>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="main-table"
          align="right"
          size="sm"
        ></b-pagination>
      </b-col>
    </b-row>

    <b-table
      class="search-table-bordeaux search-table"
      id="main-table"
      sort-icon-left
      :filter="textFilter"
      :items="results.hits"
      :fields="tableFields"
      :per-page="perPage"
      :current-page="currentPage"
      primary-key="_id"
      @row-clicked="onRowClicked"
    >
      <template #cell(expander)="data">
        <svg
          class="bi"
          width="1rem"
          height="1rem"
          fill="currentColor"
          v-if="!data.item._showDetails"
        >
          <use
            xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#chevron-bar-expand"
          />
        </svg>

        <svg class="bi" width="1rem" height="1rem" fill="currentColor" v-else>
          <use
            xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#chevron-bar-contract"
          />
        </svg>
      </template>

      <template #cell(price)="data">
        <div v-html="data.value"></div>
      </template>

      <template #cell(mobilename)="data">
        <div class="">
          {{
            data.item._source.ItemDescription[0]
              .replace(data.item._source.CaseSize, "")
              .replace("()", "")
          }}
        </div>

        <div class="mb-1 mb-md-0">
          <small>{{ data.item._source.Country[0] }} / {{ data.item._source.Region[0] }} / {{ data.item._source.Colour[0] }}</small>
        </div>

        <div
          v-if="$options.filters.resultPrice(data.item) > 0"
          class="d-md-none type-body-small-bold"
        >
          {{ data.item | resultPrice | currency }} per
          {{ data.item | resultPackage }}
        </div>
        <div
          v-else-if="data.item._source.RangeFrom && data.item._source.RangeTo"
          class="d-md-none type-body-small-bold"
        >
          Est. {{ data.item._source.RangeFrom | currency }} -
          {{ data.item._source.RangeTo | currency }} per
          {{ data.item | resultPackage }}
        </div>
      </template>

      <template slot="row-details" slot-scope="data">
        <ep-table-details show-product-page-link :result="data.item"></ep-table-details>
      </template>
    </b-table>
  </div>
</template>


<script>
import Vue from "vue";
import { BTable } from "bootstrap-vue";

import EpTableDetails from "@/components/EPTableDetails";

export default {
  components: { BTable, EpTableDetails },
  data() {
    return {
      textFilter: "",
      currentPage: 1,
      perPage: 40,
      tableFields: [
        {
          key: "expander",
          label: "",
          formatter() {
            return "";
          },
        },
         {
          key: "_source.ItemDescription[0]",
          sortable: true,
          label: "Wine Name",
          tdClass: ["d-none", "d-md-table-cell"],
          thClass: ["d-none", "d-md-table-cell"],
          formatter(value, key, item) {
            return value.replace(item._source.CaseSize, "").replace("()", "");
          },
        },
        {
          key: "mobilename",
          sortable: true,
          label: "Wine Name",
          tdClass: ["d-md-none"],
          thClass: ["d-md-none"],
          sortByFormatted(value, key, item) {
            return item._source.ItemDescription[0];
          },
          formatter() {
            return "";
          },
        },
        {
          key: "_source.Country[0]",
          sortable: true,
          tdClass: ["d-none", "d-md-table-cell"],
          thClass: ["d-none", "d-md-table-cell"],
          label: "Country / Region",
          sortByFormatted(value, key, item) {
            return item._source.Country[0] + ' / ' + item._source.Region[0];
          },
          formatter(value, key, item) {
            return item._source.Country[0] + ' / ' + item._source.Region[0];
          },
        },
        {
          key: "_source.Colour[0]",
          sortable: true,
          tdClass: ["d-none", "d-md-table-cell"],
          thClass: ["d-none", "d-md-table-cell"],
          label: "Colour",
        },
        {
          key: "_source.BottleSize",
          sortable: true,
          tdClass: ["d-none", "d-md-table-cell"],
          thClass: ["d-none", "d-md-table-cell"],
          sortByFormatted(value, key, item) {
            return item._source.PackVolume;
          },
          label: "Format",
        },
        {
          key: "price",
          sortable: true,
          label: "Price",
          tdClass: ["d-none", "d-md-table-cell"],
          thClass: ["d-none", "d-md-table-cell"],
          sortByFormatted(value, key, item) {
            if (Vue.options.filters.resultPrice(item) > 0) {
              return Vue.options.filters.resultPrice(item);
            } else if (item._source.RangeFrom && item._source.RangeTo) {
              return item._source.RangeFrom;
            } else {
              return 9999999;
            }
            
          },
          formatter(value, key, item) {
            if (Vue.options.filters.resultPrice(item)  > 0) {
              if(Vue.options.filters.wasPrice(item) !== false && Vue.options.filters.resultPrice(item) !== Vue.options.filters.wasPrice(item)) {
                return Vue.options.filters.currency(Vue.options.filters.resultPrice(item)) + "<br><small>Was: " + Vue.options.filters.currency(Vue.options.filters.wasPrice(item)) + "</small>" 
              }
              return Vue.options.filters.currency(
                  Vue.options.filters.resultPrice(item)
                );
            } else if (item._source.RangeFrom && item._source.RangeTo) {
              return (
                Vue.options.filters.currency(item._source.RangeFrom) +
                " - " +
                Vue.options.filters.currency(item._source.RangeTo)
              );
            } else {
              return "TBA";
            }
          },
        }
      ],
    };
  },
  computed: {
    rows() {
      return this.results.hits.length;
    },
  },
  methods: {
    onRowClicked(item) {
      this.$set(item, "_showDetails", !item._showDetails);
    },
  },
  props: {
    results: Object,
    hide: {
      type: Boolean,
      default: false,
    },
  },
};
</script>